import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_TITLES = {
  '/': 'Aaron Choi | Personal Trainer Portsmouth',
  '/services': 'Personal Training & Sports Massage Portsmouth | Aaron Choi',
  '/online-training': 'Online Zoom Personal Training | Aaron Choi',
  '/corporate': 'Corporate Wellness Portsmouth | Aaron Choi',
  '/retreat': 'Wellness Retreats UK | Aaron Choi',
  '/results': 'Client Transformations & Testimonials | Aaron Choi',
  '/nutrition-guide': 'Free Personalised Nutrition Guide | Aaron Choi',
  '/free-assessment': 'Free Fitness Assessment | Aaron Choi',
  '/faq': 'FAQ | Aaron Choi Personal Trainer Portsmouth',
  '/contact': 'Contact Aaron Choi | Personal Trainer Portsmouth',
  '/portal': 'Client Portal | AC Wellness & Development',
  '/portal/admin': 'Admin Dashboard | AC Wellness & Development',
  '/portal/dashboard': 'My Dashboard | AC Wellness & Development',
};

const PAGE_CANONICALS = {
  '/': 'https://aaronchoi.co.uk/',
  '/services': 'https://aaronchoi.co.uk/services',
  '/online-training': 'https://aaronchoi.co.uk/online-training',
  '/corporate': 'https://aaronchoi.co.uk/corporate',
  '/retreat': 'https://aaronchoi.co.uk/retreat',
  '/results': 'https://aaronchoi.co.uk/results',
  '/nutrition-guide': 'https://aaronchoi.co.uk/nutrition-guide',
  '/free-assessment': 'https://aaronchoi.co.uk/free-assessment',
  '/faq': 'https://aaronchoi.co.uk/faq',
  '/contact': 'https://aaronchoi.co.uk/contact',
};

const usePageSEO = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    
    // Set page title
    const title = PAGE_TITLES[path] || 'Aaron Choi | Personal Trainer Portsmouth';
    document.title = title;

    // Update canonical
    const canonical = PAGE_CANONICALS[path];
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (link) {
        link.href = canonical;
      }

      // Update OG URL
      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) ogUrl.setAttribute('content', canonical);

      let twUrl = document.querySelector('meta[property="twitter:url"]');
      if (twUrl) twUrl.setAttribute('content', canonical);

      // Update OG title
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute('content', title);

      let twTitle = document.querySelector('meta[property="twitter:title"]');
      if (twTitle) twTitle.setAttribute('content', title);
    }
  }, [location.pathname]);
};

export default usePageSEO;
